import { render, staticRenderFns } from "./FormTare.vue?vue&type=template&id=54abe93e&scoped=true"
import script from "./FormTare.vue?vue&type=script&lang=ts"
export * from "./FormTare.vue?vue&type=script&lang=ts"
import style0 from "./FormTare.vue?vue&type=style&index=0&id=54abe93e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54abe93e",
  null
  
)

export default component.exports